// I pop montati per la città (artboard 56): corpo e gambe sono immagini separate (rig.ts, generato
// da scripts/build-pop-rig.py). Le gambe stanno dietro il corpo, che ne copre il bordo alto, e
// ruotano attorno al centro di quel bordo: nessun ritaglio, nessun taglio da nascondere.
import type { Role } from './cast';
import { RIGS, type Rig } from './rig';

export interface Sprite {
  rig: Rig;
  body: HTMLImageElement;
  legL: HTMLImageElement;
  legR: HTMLImageElement;
}

/** il montaggio di un ruolo: le varianti si alternano */
export function rigFor(role: Role, variant: number): Rig {
  const list = RIGS.filter((r) => r.role === role);
  return list[variant % Math.max(1, list.length)] ?? RIGS[0];
}

async function image(src: string): Promise<HTMLImageElement> {
  const img = new Image();
  img.src = src;
  await img.decode();
  return img;
}

export async function loadSprite(rig: Rig): Promise<Sprite> {
  const [body, legL, legR] = await Promise.all(
    ['body', 'leg-l', 'leg-r'].map((part) => image(`/pops-rig/${rig.id}-${part}.webp`)),
  );
  return { rig, body, legL, legR };
}
